
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"listing"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"object_objectListing"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"headline"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"template"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"listing"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"widthBase"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"widthSM"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"widthMD"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"widthLG"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"widthXL"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"baseAR"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"smallAR"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"mediumAR"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"largeAR"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"extraLargeAR"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"xxlAR"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"imageStripeSm"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"imageStripeMd"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"imageStripeLg"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"imageStripeXl"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"imageStripeXxl"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"SliderConfig"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"object_sliderConfig"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"navigation"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"pagination"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"loop"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"breakpoints"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"fieldcollection_sliderBreakpoint"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"minWidth"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"options"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"option"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"optionValue"},"arguments":[],"directives":[]}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"newsAllLinks"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"generalLinks"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"content"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"element"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"partner"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"teaser"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"asset"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"page"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"hole"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"team"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"trainer"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"lesson"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"partnerClub"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"testimonial"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"boardMember"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"event"},"directives":[]}]}}]}}]}}],"loc":{"start":0,"end":1088}};
    doc.loc.source = {"body":"fragment listing on object_objectListing {\n    id\n    headline\n    template\n    listing\n    widthBase\n    widthSM\n    widthMD\n    widthLG\n    widthXL\n    baseAR\n    smallAR\n    mediumAR\n    largeAR\n    extraLargeAR\n    xxlAR\n    imageStripeSm\n    imageStripeMd\n    imageStripeLg\n    imageStripeXl\n    imageStripeXxl\n    SliderConfig  {\n        ... on object_sliderConfig {\n            navigation\n            pagination\n            loop\n            breakpoints {\n                ... on fieldcollection_sliderBreakpoint {\n                    minWidth\n                    options {\n                        option\n                        optionValue\n                    }\n                }\n            }\n        }\n    }\n    newsAllLinks {\n        ...generalLinks\n    }\n    content {\n        element {\n            ...partner\n            ...teaser\n            ...asset\n            ...page\n            ...hole\n            ...team\n            ...trainer\n            ...lesson\n            ...partnerClub\n            ...testimonial\n            ...boardMember\n            ...event\n        }\n    }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["listing"] = oneQuery(doc, "listing");
        
